document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ cross-sell.js loaded");

  // -------------------------
  // ✅ INIT COMPLETE LOOK SWIPER
  // -------------------------
  function initCompleteLookSwiper() {
    const container = document.querySelector("#complete-look-container");
    if (!container) return;

    const slider = container.querySelector(".complete-look__slider");
    if (!slider) return;

    // Destroy existing instance if any
    if (window.completeLookSwiper) window.completeLookSwiper.destroy(true, true);

    // Init Swiper
    window.completeLookSwiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: false,
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      pagination: false,
      on: {
        init(swiper) {
          updateArrows(swiper);
        },
        slideChange(swiper) {
          updateArrows(swiper);
        },
      },
    });

    function updateArrows(swiper) {
      const prevBtn = swiper.params.navigation.prevEl;
      const nextBtn = swiper.params.navigation.nextEl;
      if (!prevBtn || !nextBtn) return;

      prevBtn.classList.toggle("swiper-button-disabled", swiper.isBeginning);
      nextBtn.classList.toggle("swiper-button-disabled", swiper.isEnd);
    }
  }

  // -------------------------
  // ✅ INIT CART CROSS SELL SWIPER
  // -------------------------
  function initCartCrossSellSwiper() {
    const container =
      document.querySelector("#cart-cross-sell-container") ||
      document.querySelector("#cart-cross-sell-fallback");
    if (!container) return;

    const slider = container.querySelector(".cart-cross-sell__slider");
    if (!slider) return;

    if (window.cartCrossSellSwiper) window.cartCrossSellSwiper.destroy(true, true);

    window.cartCrossSellSwiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: false,
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      pagination: false,
    });
  }

  // -------------------------
  // ✅ COMPLETE LOOK SECTION INIT + FALLBACK
  // -------------------------
  const completeLookContainer = document.getElementById("complete-look-container");
  if (completeLookContainer) {
    const productId = completeLookContainer.getAttribute("data-product-id");
    const hasReco = completeLookContainer.getAttribute("data-has-reco") === "true";

    // Init Swiper immediately
    initCompleteLookSwiper();

    // Fetch recommendations if missing
    if (!hasReco) {
      fetch(
        `/recommendations/products?product_id=${productId}&limit=6&section_id=complete-the-look-section`
      )
        .then((resp) => resp.text())
        .then((html) => {
          if (html.trim() !== "") {
            completeLookContainer.innerHTML = html;
            initCompleteLookSwiper();
            if (typeof AOS !== "undefined") AOS.refreshHard();
          }
        });
    }
  }

  // -------------------------
  // ✅ FALLBACK CROSS SELL
  // -------------------------
  const fallback = document.getElementById("cart-cross-sell-fallback");
  if (fallback) {
    const productId = fallback.dataset.productId;
    const cartItemIds = Array.from(
      document.querySelectorAll(".cart_item-qty-remove input.js-qty__num")
    ).map((input) => Number(input.dataset.id));

    fetch(
      `/recommendations/products?product_id=${productId}&limit=6&section_id=complete-the-look-section`
    )
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const products = doc.querySelectorAll(".complete-look__item, .grid__item");
        const wrapper = fallback.querySelector(".js-reco-wrapper");

        if (products.length && wrapper) {
          products.forEach((item) => {
            const recoId = Number(item.dataset.productId);
            if (!cartItemIds.includes(recoId)) wrapper.appendChild(item);
          });
          initCartCrossSellSwiper(); // ✅ re-init after appending
        }
      })
      .catch((err) => console.error("Error fetching recommendations:", err));
  }

  // -------------------------
  // ✅ AOS INIT
  // -------------------------
  if (typeof AOS !== "undefined") {
    AOS.init({ duration: 100, once: true });
  }

  // -------------------------
  // ✅ ADD TO CART (CROSS SELL)
  // -------------------------
  document.addEventListener("click", async function (e) {
    const button = e.target.closest(".crossSell-btn-add, .cart-crossSell-btn-add");
    if (!button) return;

    e.preventDefault();
    const variantId = button.dataset.variantId;
    if (!variantId) return console.error("❌ No variant ID found");

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });

      if (!res.ok) throw new Error(await res.text());
      console.log("✅ Cross-sell product added");
      await updateCartDrawer();
    } catch (err) {
      console.error("❌ Add to cart failed:", err);
    }
  });

  // -------------------------
  // ✅ UPDATE CART DRAWER
  // -------------------------
  async function updateCartDrawer() {
  try {
    const res = await fetch("/?sections=cart-drawer");
    const data = await res.json();
    const parser = new DOMParser();
    const newHtml = parser.parseFromString(data["cart-drawer"], "text/html");
    const newDrawer = newHtml.querySelector("#CartDrawer");
    let currentDrawer = document.querySelector("#CartDrawer");

    if (!currentDrawer) {
      document.body.insertAdjacentElement("beforeend", newDrawer);
      currentDrawer = newDrawer;
    } else {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    // ✅ Re-fetch cross-sell recommendations and re-init swiper
    const fallback = document.getElementById("cart-cross-sell-fallback");
    if (fallback) {
      const productId = fallback.dataset.productId;
      const cartItemIds = Array.from(
        document.querySelectorAll(".cart_item-qty-remove input.js-qty__num")
      ).map((input) => Number(input.dataset.id));

      const recos = await fetch(
        `/recommendations/products?product_id=${productId}&limit=6&section_id=complete-the-look-section`
      );
      const html = await recos.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const products = doc.querySelectorAll(".complete-look__item, .grid__item");
      const wrapper = fallback.querySelector(".js-reco-wrapper");

      if (products.length && wrapper) {
        wrapper.innerHTML = ""; // clear old
        products.forEach((item) => {
          const recoId = Number(item.dataset.productId);
          if (!cartItemIds.includes(recoId)) wrapper.appendChild(item);
        });
        initCartCrossSellSwiper();
        syncInsuranceCheckbox();
      }
    }

    // ✅ Keep rest of your existing logic
    currentDrawer.querySelectorAll("img").forEach((img) => {
      img.addEventListener("load", () => (img.style.opacity = 1));
      if (img.complete) img.style.opacity = 1;
    });

    if (window.lazySizes && typeof lazySizes.loader !== "undefined") {
      lazySizes.loader.unveil(currentDrawer.querySelectorAll("img"));
    }

    currentDrawer.classList.remove("is-empty");
    currentDrawer.classList.add("drawer--is-open");
    document.documentElement.classList.add("js-drawer-open");

    if (typeof AOS !== "undefined" && typeof AOS.refreshHard === "function") {
      AOS.refreshHard();
    }

    document.dispatchEvent(new CustomEvent("shopify:section:load"));
    if (window.Shopify?.theme?.sections)
      Shopify.theme.sections.reinit("cart-drawer");
  } catch (err) {
    console.error("Error updating cart drawer:", err);
  }
}


  // -------------------------
  // ✅ VARIANT CHANGE HANDLER
  // -------------------------
  document.addEventListener("variant:change", function (e) {
    const mainVariant = e.detail.variant;
    if (!mainVariant) return;

    const items = document.querySelectorAll("#complete-look-container .complete-look__item");
    let foundMatch = false;

    items.forEach((item) => {
      let match = true;
      if (mainVariant.option1 && item.dataset.option1 !== mainVariant.option1)
        match = false;
      if (mainVariant.option2 && item.dataset.option2 !== mainVariant.option2)
        match = false;
      if (mainVariant.option3 && item.dataset.option3 !== mainVariant.option3)
        match = false;
      item.style.display = match ? "flex" : "none";
      if (match) foundMatch = true;
    });

    if (!foundMatch) items.forEach((item) => (item.style.display = "flex"));
    if (window.completeLookSwiper) window.completeLookSwiper.update();
  });

  // -------------------------
  // ✅ HIDE SPECIFIC PRODUCT
  // -------------------------
  const hideItem = document.querySelector(
    '.complete-look__item[data-product-id="9871330607399"]'
  );
  if (hideItem) hideItem.style.display = "none";
});


const PROTECTION_PRODUCT_ID = 9871330607399; // your insurance product ID
const PROTECTION_VARIANT_ID = 54074377379063; // your insurance variant ID

async function syncInsuranceCheckbox() {
  try {
    const cart = await fetch("/cart.js").then(res => res.json());
    const hasInsurance = cart.items.some(
      item =>
        item.product_id === PROTECTION_PRODUCT_ID ||
        item.variant_id === PROTECTION_VARIANT_ID
    );

    const checkbox = document.querySelector(".protection-product");
    if (checkbox) {
      checkbox.checked = hasInsurance; // ✅ check if insurance is in cart
    }
  } catch (err) {
    console.error("Error syncing insurance checkbox:", err);
  }
}

// ✅ Run once on load
syncInsuranceCheckbox();

// ✅ Optionally run after cart updates
document.addEventListener("cart:updated", syncInsuranceCheckbox);
